/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import {
    m11EligibilityCriteriaFoiChanged, m11EligibilityCriteriaResourceChanged,
    m11ResearchStudyResourceChanged, selectM11EligibilityCriteriaFoi,
    selectM11EligibilityCriteriaResource, selectM11ReportContainerFoi, selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import getIdFromReference from "../../functions/getIdFromReference";
import getFhirJson from "../../functions/getFhirJsonAPI";
import jsonEquals from "../../functions/jsonEquals";
import StringEntry from "../../datatypeComponents/StringEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveEligibilityChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    eligibilityState, descriptionState, setAlertModalState, setStartingDescriptionState, setStartingEiigibilityState) => {

    let changesStates = {
        descriptionState: descriptionState,
        eligibilityState: eligibilityState
    };
    let response = await saveM11Changes(apiToken, 6, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ResearchStudyResource) {
            dispatch(m11ResearchStudyResourceChanged(response.m11ResearchStudyResource));
        }
        if (response.m11EligibilityCriteriaResource) {
            dispatch(m11EligibilityCriteriaResourceChanged(response.m11EligibilityCriteriaResource));
        }
        setStartingDescriptionState(JSON.parse(JSON.stringify(descriptionState)));
        setStartingEiigibilityState(JSON.parse(JSON.stringify(eligibilityState)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const loadGroupResource = async (groupFoi, dispatch, apiToken) => {
    let groupJson = await getFhirJson(groupFoi, null, apiToken);
    if (groupJson) {
        dispatch(m11EligibilityCriteriaResourceChanged(groupJson));
    }
};

const M11Step006Eligibility = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11EligibilityCriteriaFoi = useSelector(selectM11EligibilityCriteriaFoi);
    const m11EligibilityCriteriaResource = useSelector(selectM11EligibilityCriteriaResource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);
        const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);

    const [descriptionState, setDescriptionState] = useState({
        "description": ""
    });
    const [startingDescriptionState, setStartingDescriptionState] = useState({
        "description": ""
    });
    const [eligibilityState, setEligibilityState] = useState({
        "inclusionCriteria": "", "exclusionCriteria": ""
    });
    const [startingEligibilityState, setStartingEiigibilityState] = useState({
        "inclusionCriteria": "", "exclusionCriteria": ""
    });

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && (descriptionState.description !== startingDescriptionState.description ||
            !jsonEquals(eligibilityState, startingEligibilityState))),
        async saveAllChanges() {
            await saveEligibilityChanges(dispatch, apiToken, m11ResearchStudyFoi,
                eligibilityState, descriptionState, setAlertModalState,
                 setStartingDescriptionState, setStartingEiigibilityState);
        }
    }));

    useEffect(() => {
        if (m11EligibilityCriteriaFoi && !isNaN(m11EligibilityCriteriaFoi)) {
            loadGroupResource(m11EligibilityCriteriaFoi, dispatch, apiToken);
        }
    }, [m11EligibilityCriteriaFoi]);

    useEffect(() => {
        let startingEligibilityCriteria = {
            "inclusionCriteria": "", "exclusionCriteria": ""
        };
        if (m11EligibilityCriteriaResource && Object.keys(m11EligibilityCriteriaResource).length > 0 &&
            m11EligibilityCriteriaResource.characteristic?.length > 0) {
            let inclusionList = [];
            let exclusionList = [];
            for (const characteristic of m11EligibilityCriteriaResource.characteristic) {
                if (characteristic.description && characteristic.exclude === false) {
                    inclusionList.push(characteristic.description);
                }
                if (characteristic.description && characteristic.exclude === true) {
                    exclusionList.push(characteristic.description);
                }
            }
            if (inclusionList.length > 0) {
                startingEligibilityCriteria.inclusionCriteria = inclusionList.join("\n");
            }
            if (exclusionList.length > 0) {
                startingEligibilityCriteria.exclusionCriteria = exclusionList.join("\n");
            }
        }
        startingEligibilityCriteria.loaded = true;
        setEligibilityState(startingEligibilityCriteria);
        setStartingEiigibilityState(startingEligibilityCriteria);
    }, [m11EligibilityCriteriaResource]);

    useEffect(() => {
        if (m11ResearchStudyResource) {
            let startingRecruitment = {
                "description": ""
            };
            if (m11ResearchStudyResource.recruitment?.description) {
                startingRecruitment.description = m11ResearchStudyResource.recruitment.description;
            }
            if (m11ResearchStudyResource.recruitment?.eligibility &&
                getIdFromReference(m11ResearchStudyResource.recruitment.eligibility)) {
                let groupFoi = getIdFromReference(m11ResearchStudyResource.recruitment.eligibility);
                if (groupFoi && !isNaN(groupFoi) && groupFoi !== m11EligibilityCriteriaFoi) {
                    dispatch(m11EligibilityCriteriaFoiChanged(groupFoi));
                }
            }
            startingRecruitment.loaded = true;
            setDescriptionState(startingRecruitment);
            setStartingDescriptionState(startingRecruitment);
        }
    }, [m11ResearchStudyResource]);

    return <div>
        <h3>Enter M11ResearchStudy Study Eligibility (Inclusion and Exclusion) Criteria</h3>
        {!m11ReportContainerFoi &&
        <h1 style={{color: "red"}}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        <h4 style={{ marginBottom: "0px" }}>Enter Description of Trial Population and Rationale</h4>
        {descriptionState.loaded &&
            <StringEntry elementName='description'
                fieldLabel='Description of Trial Population and Rationale'
                startingValue={descriptionState.description}
                setResourceState={setDescriptionState} />}
        <h4 style={{ marginBottom: "0px" }}>Enter Inclusion and Exclusion Criteria</h4>
        {eligibilityState.loaded && <>
            <p>For each list below (the inclusion criteria list and the exclusion criteria list), enter the criteria with line breaks so there is one criterion per line. Edit the data as needed so that there is only one criterion per line without nested lists or organizing statements. The system will structure this as a numbered list of criteria with the appropriate headings and opening statements.</p>
            <h4 style={{ marginBottom: "0px" }}>List the Inclusion Criteria, one criterion per line.</h4>
            <StringEntry elementName='inclusionCriteria'
                fieldLabel='Inclusion Criteria'
                startingValue={eligibilityState.inclusionCriteria}
                setResourceState={setEligibilityState} />
            <h4 style={{ marginBottom: "0px" }}>List the Exclusion Criteria, one criterion per line.</h4>
            <StringEntry elementName='exclusionCriteria'
                fieldLabel='Exclusion Criteria'
                startingValue={eligibilityState.exclusionCriteria}
                setResourceState={setEligibilityState} />
        </>}
    </div>
});

const M11Step006EligibilityHelperText = <div>
    <h3>Enter M11ResearchStudy Study Eligibility (Inclusion and Exclusion) Criteria</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter a description of the trial population and rationale. This will be used for Section 5.1 Description of Trial Population and Rationale.</p>
        <div style={{ marginLeft: "24px" }}>
            <p>Describe the population selected (e.g., healthy participants, adult participants, paediatric participants, pregnant participants, or breastfeeding participants) and how the enrollment criteria reflect the populations that are likely to use the drug if approved. Specify the population age range (e.g., ≤ 3 months, ≥ 18 to ≤ 80 years old) including the timepoint at which qualification for age criteria is determined (e.g., at time of screening vs randomisation for paediatric trials). Specify any key diagnostic criteria for the population (e.g., “acute lung injury”, or a specific biomarker profile). If applicable, describe similar conditions or diseases and their differential diagnosis.</p>
            <p>Provide a rationale for the trial population ensuring that the population selected is well defined and clinically recognisable. Describe how the selected population can meet the trial objectives and how the enrollment criteria reflect the population of interest. If a clinical question targets a subset of the entire trial population, such as one defined by a baseline characteristic (e.g., a specific biomarker), the rationale for selecting this subset should be provided in this section.</p>
            <p>Justify whether the trial intervention is to be evaluated in paediatric participants, in adults unable to consent for themselves, other vulnerable participant populations, or those that may respond to the trial intervention differently (e.g., elderly, hepatic or renally impaired, or immunocompromised participants).</p>
        </div>
        <br />
        <p>For the inclusion criteria list, enter the criteria with line breaks so there is one criterion per line.</p>
        <div style={{ marginLeft: "24px" }}>
            <p>Inclusion criteria are characteristics that define the trial population, i.e., those criteria that every potential participant must satisfy to qualify for trial enrollment.</p>
            <p>Edit the data as needed so that there is only one criterion per line without nested lists or organizing statements. The system will structure this as a numbered list of criteria with the appropriate heading and opening statement.</p>
        </div>
        <br />
        <p>For the exclusion criteria list, enter the criteria with line breaks so there is one criterion per line.</p>
        <div style={{ marginLeft: "24px" }}>
            <p>Exclusion criteria are characteristics that make an individual ineligible for participation.</p>
            <p>Edit the data as needed so that there is only one criterion per line without nested lists or organizing statements. The system will structure this as a numbered list of criteria with the appropriate heading and opening statement.</p>
        </div>
        <br />
        <p>Click the 'Save All Changes' button.</p>
        <br />
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step006EligibilityValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 6, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
        <h4>Step 6 (Enter M11ResearchStudy Study Eligibility (Inclusion and Exclusion) Criteria) {validationCheckState.step06numberOfChecks} issues checked. {validationCheckState.step06numberPassed} passed. {validationCheckState.step06numberFailed} failed.</h4>
        <p>Description of Trial Population and Rationale has data stored in M11ResearchStudy Resource: {validationCheckState.resultCheckTrialPopulation}</p>
        <p>Inclusion Criteria has data stored in StudyEligibilityCriteria Resource: {validationCheckState.resultCheckInclusionCriteiria}</p>
    </div>}  </div>
}

export default M11Step006Eligibility;
export { M11Step006EligibilityHelperText, M11Step006EligibilityValidationCheck };